import styled from 'styled-components/macro';
import { FlexNoAlign, FlexJustifyBetween } from '../../../../shared-styles/flex';

export const AutomatedEventsFilterContainer = styled.div`
  ${FlexNoAlign}
`;

export const ActivityTypeFilterContainer = styled.div`
  width: 230px;
`;

export const FilterContainer = styled.div`
  ${FlexJustifyBetween};
  padding: ${(props) => props.theme.spacing(10)} ${(props) => props.theme.spacing(20)};
  border-bottom: 2px dashed ${(props) => props.theme.palette.lightGray[100]};
}
`;

export const ContentContainer = styled.div`
  max-height: 760px;
  overflow-y: scroll;
`;
